module.exports = __webpack_public_path__ + "images/main-attraction-265e148d98e41eb61c1eaec2938e5955.png";